import IssueReportEvents from './issueReportsEvents';

const Events = {
    IssueReport: IssueReportEvents,
};

export default Events;
